import WithRender from "../../templates/buttons/previewButton.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPackingOptionsData", "getPreviewLoading"]),
    getDisableClass: function () {
      return this.getPreviewLoading ? "disable" : "";
    }
  },
  methods: {
    ...mapActions(["packingGetData"]),
    onClickPreview: function () {
      // debounce ???
      this.packingGetData({ wnd: this, callChangeOptions: true });
    }
  }
});
